import { FormControl, FormControlLabel, InputLabel, MenuItem, Select, SelectChangeEvent, Switch } from '@mui/material';
import { DashboardYearFilter } from '../components/DashboardYearFilter';
import { useGPASubmissionData } from '../contexts/GPASubmissionDataContext';

const values = (event: SelectChangeEvent<number[]>) => typeof event.target.value === 'string'
    ? event.target.value.split(',').map(Number) : event.target.value;

interface Props {
    showFileId?: boolean;
    onShowFileIdChange?: (showFileId: boolean) => void;
}

export const GPASubmissionFilterControls = ({ showFileId, onShowFileIdChange }: Props = {}) => {
    const { filter, updateFilter, activeSchoolYear, schools, gradeLevels, termTypes } = useGPASubmissionData();
    const maxTermCount = termTypes.filter(type => !filter.termTypeIds.length || filter.termTypeIds.includes(type.id))
        .reduce((maximum, type) => Math.max(maximum, type.termCount || 0), 0);
    const termNumbers = Array.from({ length: maxTermCount }, (_, index) => index + 1);

    return <DashboardYearFilter idPrefix="gpa-submission" years={filter.schoolYears} activeSchoolYear={activeSchoolYear}
        onApply={schoolYears => updateFilter({ schoolYears })}>
        <FormControl size="small" sx={{ minWidth: 190 }}><InputLabel>Schools</InputLabel>
            <Select multiple value={filter.schoolIds} label="Schools" onChange={event => updateFilter({ schoolIds: values(event) })}
                renderValue={selected => selected.length ? `${selected.length} selected` : 'All Schools'}>
                {schools.map(option => <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>)}
            </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 170 }}><InputLabel>Grade Levels</InputLabel>
            <Select multiple value={filter.gradeLevelIds} label="Grade Levels" onChange={event => updateFilter({ gradeLevelIds: values(event) })}
                renderValue={selected => selected.length ? `${selected.length} selected` : 'All Grade Levels'}>
                {gradeLevels.map(option => <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>)}
            </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 170 }}><InputLabel>Term Types</InputLabel>
            <Select multiple value={filter.termTypeIds} label="Term Types" onChange={event => updateFilter({ termTypeIds: values(event), termNumbers: [] })}
                renderValue={selected => selected.length ? `${selected.length} selected` : 'All Term Types'}>
                {termTypes.map(option => <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>)}
            </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 170 }}><InputLabel>Term Numbers</InputLabel>
            <Select multiple value={filter.termNumbers} label="Term Numbers"
                onChange={event => updateFilter({ termNumbers: values(event) })}
                renderValue={selected => selected.length ? selected.join(', ') : 'All Terms'}>
                {termNumbers.map(number => <MenuItem key={number} value={number}>{number}</MenuItem>)}
            </Select>
        </FormControl>
        {onShowFileIdChange && <FormControlLabel
            label="File ID"
            sx={{ ml: 0.5, mr: 0 }}
            control={<Switch size="small" checked={showFileId || false}
                onChange={event => onShowFileIdChange(event.target.checked)} />}
        />}
    </DashboardYearFilter>;
};
